import { mapGetters, mapState } from 'vuex';
import appHeader from '@/components/app/app-header/app-header.vue';
import appSecondaryNav from '@/components/app/app-secondary-nav/app-secondary-nav.vue';
import appMainNav from '@/components/app/app-main-nav/app-main-nav.vue';
import appBottomNav from '@/components/app/app-bottom-nav/app-bottom-nav.vue';
import appMobileMenu from '@/components/app/app-mobile-menu/app-mobile-menu.vue';
import appFooter from '@/components/app/app-footer/app-footer.vue';
import notificationItems from '@/components/notification-items/notification-items.vue';
import appHeaderNotification from '@/components/app/app-header-notification/app-header-notification.vue';
import maintenanceNotification from '@/components/maintenance-notification/maintenance-notification.vue';
import searchBar from '@/components/app/app-header/search-bar/search-bar.vue';
import sideNotification from '@/components/generics/side-notification/side-notification.vue';
import constants from '@/constants';
import { isStandalone } from '@/mixins/userAgent';
import navBrowseCategoriesOverlay
  from '@/components/app/app-secondary-nav/nav-browse-categories-overlay/nav-browse-categories-overlay.vue';
const SIMPLE_LAYOUT_ROUTES = [
  'disqus-auth',
  'disqus-logout',
];


export default {
  components: {
    appHeader,
    appHeaderNotification,
    appSecondaryNav,
    appMainNav,
    appBottomNav,
    appFooter,
    appMobileMenu,
    maintenanceNotification,
    notificationItems,
    searchBar,
    sideNotification,
    navBrowseCategoriesOverlay,
  },
  data() {
    return {
      isStandalone,
      isTransitioning: false,
    };
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.isTransitioning = false;
      }, 1000);
    },
  },
  methods: {
    onBeforeLeave() {
      this.isTransitioning = true;
    },
    onAfterEnter() {
      this.isTransitioning = false;
      window.scrollTo(0, 0);
    },
  },
  computed: {
    ...mapGetters('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutDesktop']),
    ...mapState('app', ['hasServerErrorOccurred', 'liveUpdatesDisabled', 'mobileMenuOpened']),
    ...mapState('popup', ['currentPopup', 'currentSmallPopup']),
    ...mapState('notifications', [
      'sideNotificationLevel',
      'sideNotificationText',
      'sideNotificationOnCloseCallback',
      'showNotificationsWidget',
    ]),
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isUserRestricted']),
    ...mapState('search', ['searchBarVisible']),
    isSimpleLayout() {
      return SIMPLE_LAYOUT_ROUTES.includes(this.$route.name);
    },
    appModifiers() {
      return {
        'app-layout': true,
        'app-layout--with-overflow': (
          (this.currentPopup !== null || this.currentSmallPopup !== null) && this.isTransitioning
        ),
        'app-layout--full-width': this.$route.meta.appContentFullWidth,
        'app-layout--bg-white': true,
      };
    },
    headerModifiers() {
      return {
        'app-layout__header': true,
        'app-layout__header--secondary': true,
        'app-layout__header--error': !isStandalone && (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout__header--notifications-widget-open': this.showNotificationsWidget,
      };
    },
    contentModifiers() {
      return {
        'app-layout__content': true,
        'app-layout__content--secondary': !this.isSimpleLayout,
        'app-layout__content--simple': this.isSimpleLayout,
        'app-layout__content--error': !isStandalone && (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled),
        'app-layout__content--with-overflow': this.$route.meta.appContentOverflowed,
        'app-layout__content--full-width': this.$route.meta.appContentFullWidth,
      };
    },
    sideNotificationShouldDisplay() {
      return this.sideNotificationLevel && this.sideNotificationText;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-layout/app-layout.js